
import {makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles( theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: '0.3rem',
        width: '100%'
    },
}))

export default useStyles